<template lang="pug">
  div(:class="'container-'+this._uid")
    h1(class="page-title") {{this.title}}
    div(class="desc") {{this.desc}}
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'
import anime from 'animejs'

// Storing animation target elements
const animTargets = {
  container: '#container'
}

// component instance
var textblockImgLeft = Vue.component('textblock-img-left', {
  name: 'textblockImgLeft',
  mixins: [sectionBase],
  props: ['title', 'body', 'image'],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
    actions () {
      // let component = this

      return {
        SET: () => {
          return anime({
            targets: animTargets.container + this._uid,
            easing: 'easeInOutQuad',
            opacity: [
              { value: '1' }
            ],
            translateX: [
              { value: 0 }
            ],
            translateY: [
              { value: 0 }
            ],
            borderColor: [
              { value: '#F0F0F0' }
            ],
            boxShadow: [
              { value: '0px 0px 10px rgba(211,211,211,1)' }
            ],
            duration: 200,
            begin: function (e) {
              console.log('set')
            },
            complete: function () {
            }
          })
        }
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default textblockImgLeft
</script>

<style scoped>
  .page-title{

  }
</style>



// WEBPACK FOOTER //
// src/components/sections/textblockImgLeft.vue